import { render, staticRenderFns } from "./ChangeHub.vue?vue&type=template&id=117e1433&scoped=true&"
import script from "./ChangeHub.vue?vue&type=script&lang=js&"
export * from "./ChangeHub.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHub.vue?vue&type=style&index=0&id=117e1433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e1433",
  null
  
)

export default component.exports